'use strict';

var templates = require('../templates');
var fobclient = require('..');
var Sdg = require('../entity').Sdg;

module.exports = function (connection) {
  return {
    byMultiValueSearchRep: function byMultiValueSearchRep(searchParams) {
      return templates.genericSearchTemplate(connection)(Sdg, 'byMultiValueSearchRep')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('sdg')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/sdg.js
// module id = slPa
// module chunks = 0